import { Check } from '@mui/icons-material'
import {
  useEditUserEmailDataMutation,
  useReSendEditEmailMutation,
} from 'feature/user/redux/user.api'
import { TEditEmailRequest, User } from 'feature/user/types'
import { useSetNotice } from 'hooks/useSetNotice'
import { useEffect, useState } from 'react'
import {
  Controller,
  FieldValues,
  SubmitHandler,
  useFormContext,
} from 'react-hook-form'
import { Button, TextField } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { Severity } from 'widget/Notifications'

import { SendEmailConfirmBlock } from '../SendEmailConfirmBlock/SendEmailConfirmBlock'

import style from './EmailSettingsForm.module.scss'

type TEmailSettingsForm = {
  data: User | undefined
}

// страница редактирования email
export const EmailSettingsForm = ({ data }: TEmailSettingsForm) => {
  const [sendNewMail, { isLoading: sendEditEmailLoading }] =
    useEditUserEmailDataMutation()
  const [reSendEmailConfirm, { isLoading: resendEditEmailLoading }] =
    useReSendEditEmailMutation()
  const [isButtonDeactivate, setIsButtonDeactivate] = useState<boolean>(true)
  const setNotice = useSetNotice()

  const {
    handleSubmit,
    formState: { isValid },
    control,
    watch,
  } = useFormContext()

  const emailWatchField = watch('email')

  useEffect(() => {
    if (emailWatchField === data?.newEmail) {
      setIsButtonDeactivate(true)
      return
    }
    if (!data?.newEmail && emailWatchField === data?.email) {
      setIsButtonDeactivate(true)
      return
    }

    setIsButtonDeactivate(false)
  }, [emailWatchField])

  const onSubmit: SubmitHandler<FieldValues> = values => {
    if (values.email?.length) {
      const requestBoby: TEditEmailRequest = {
        newEmail: values.email,
      }
      sendNewMail(requestBoby)
        .then(res => {
          if ('error' in res) {
            //@ts-ignore
            const error = res.error.data
            setNotice(error.message, Severity.error)
          } else {
            setIsButtonDeactivate(true)
            setNotice(res.data.message, Severity.success)
          }
        })
        .catch(error => {
          console.warn('error', error)
        })
    }
  }

  const sendConfirm = () => {
    reSendEmailConfirm().then(res => {
      if ('error' in res) {
        //@ts-ignore
        const error = res.error.data

        setNotice(error.message, Severity.error)
      } else {
        setNotice(res.data.message, Severity.success)
      }
    })
  }

  const isConfirmBlockVisible =
    data?.email === emailWatchField || data?.newEmail === emailWatchField

  return (
    <form className={style.form} onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Controller
          name='email'
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              className={style.emailInput}
              label='Электронная почта'
              inputProps={{ maxLength: 120, autoComplete: 'off' }}
              data-testid='email-settings-input'
              {...field}
              error={!!fieldState?.error}
              helperText={fieldState?.error?.message}
            />
          )}
        />

        {isConfirmBlockVisible && (
          <SendEmailConfirmBlock
            data={data}
            sendConfirm={sendConfirm}
            isEmailValid={isValid}
            resendEditEmailLoading={resendEditEmailLoading}
          />
        )}
      </div>

      <Button
        startIcon={<Check />}
        variant='contained'
        disabled={isButtonDeactivate || !isValid || sendEditEmailLoading}
        type='submit'
        color='primary'
        className={style.submitButton}
        data-testid='email-settings-submit'
      >
        {sendEditEmailLoading && (
          <LoaderInCentalPosition className={style.loader} />
        )}
        Сохранить изменения
      </Button>
    </form>
  )
}
